import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel2";
import { tConvert, redirectionWrapper, convertToSlug, IsEmpty, getSeriesDescHtml } from "../../../util/commonFunctions";
import { showLoader, hideLoader } from "../../../actions";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";



class Carousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      options: { ...state.options, ...props.crouselOption },
      showSchedule: props.showSchedule == undefined ? true : props.showSchedule
    };
  }


  crouselSlides = slides => {
    let returnSlide;
    switch (this.props.railType.toLowerCase()) {
      case "epg":
        returnSlide = slides.map((slide, index) => {
          return (
            <div
              key={"slide" + index}
              className="epgSlide row no-gutter align-items-center"
            >
              <div className="col-6">
                <span className="epgTime">{tConvert(slide.startDateTime)}</span>
              </div>
              {this.props.showLive &&
                this.state.options.startPosition >= 0 &&
                index == this.state.options.startPosition &&
                this.props.dataType.toLowerCase() == "today" && (
                  <div className="col-6">
                    <p className="liveText text-right">
                      <span className="liveCircle"></span>LIVE
                    </p>
                  </div>
                )}
              <div className="col-12">
                {!IsEmpty(slide.eventSeries) &&
                  <h4>
                    <Link
                      to={{
                        pathname: `/series/${convertToSlug(slide.eventSeries.name)}?seriesID=${slide.eventSeries.id}`,
                      }}
                      onClick={(event) => {
                        redirectionWrapper(
                          'series',
                          event,
                          slide.eventSeries.id,
                          slide.eventSeries.name,
                          this.props,
                          this.props.showLoader,
                          this.props.hideLoader,
                          this.props.currentLanguage
                        )
                      }}
                    >
                      {slide.eventSeries.name}
                    </Link>
                  </h4>
                }
                {IsEmpty(slide.eventSeries) && !IsEmpty(slide.show) &&
                  <h4>{slide.show}</h4>
                }
              </div>
              <div className="col-12">
                {!IsEmpty(slide.eventSeries) &&
                  <p
                    className="description"
                    dangerouslySetInnerHTML={getSeriesDescHtml(slide.htmlSummary, slide.eventSeries.description)}
                  >
                  </p>
                }
                {IsEmpty(slide.eventSeries) && !IsEmpty(slide.showSummary) &&
                  <p>{slide.showSummary}</p>
                }
              </div>
              {this.state.showSchedule &&
                <>
                  {slide.guest && (
                    <div className="col-12">
                      <h6>FEATURED GUESTS</h6>
                      <p className="guest-name">{slide.guest}</p>
                    </div>
                  )}
                  {slide.experts.length > 0 && (
                    <div className="col-12">
                      <h6>FEATURED EXPERTS</h6>
                      <ul className="feature-expert">
                        {slide.experts.map((expert, expertIndex) => {
                          return (
                            <li
                            key={`EpgExpert-${expertIndex}`}
                            onClick={(event) => {
                              redirectionWrapper(
                                'expert',
                                event,
                                expert.id,
                                expert.name,
                                this.props,
                                this.props.showLoader,
                                this.props.hideLoader,
                                this.props.currentLanguage
                              )
                            }}
                            >
                              <div className="circle-img">
                                <img
                                  src={expert.url}
                                  alt=""
                                  onClick={(event) => {
                                    redirectionWrapper(
                                      'expert',
                                      event,
                                      expert.id,
                                      expert.name,
                                      this.props,
                                      this.props.showLoader,
                                      this.props.hideLoader,
                                      this.props.currentLanguage
                                    )
                                  }}
                                  style={{ cursor: 'pointer' }}
                                  />
                              </div>
                              <span><a href={`/expert/${expert.name}/${expert.id}`}>{expert.name}</a></span>
                            </li>
                          );
                        })
                      }
                      </ul>
                    </div>
                  )}
                </>
              } 
            </div>
          );
        });
        break;
      case "experts":
        returnSlide = slides.map((slide, index) => {
          return (
            <div className="expert-list" key={"slide" + index}>
              <figure style={{ cursor: 'pointer' }} onClick={(event) => {
                redirectionWrapper(
                  'expert',
                  event,
                  slide.id,
                  slide.name,
                  this.props,
                  this.props.showLoader,
                  this.props.hideLoader,
                  this.props.currentLanguage
                )
              }}>
                <img src={slide.url} alt="expert" />
              </figure>
              <div className="min-height-box" onClick={(event) => {
                redirectionWrapper(
                  'expert',
                  event,
                  slide.id,
                  slide.name,
                  this.props,
                  this.props.showLoader,
                  this.props.hideLoader,
                  this.props.currentLanguage
                )
              }}>
                <strong>{slide.name}</strong>
                <span>{slide.role}</span>
                {typeof slide.company === 'string' && <p>{slide.company}</p>}
              </div>
              {!slide.isFollowing &&
                <div className="follow-list" onClick={() => this.props.followObject(slide.id, "expert")}>
                  <span></span>
                  <strong>Follow</strong>
                </div>
              }
              {slide.isFollowing &&
                <div className="follow-list  follow-list-gray" onClick={() => this.props.unFollowObject(slide.id, "expert")}>
                  <span></span>
                  <strong>Following</strong>
                </div>
              }
            </div>
          );
        });
        break;
      default:
        break;
    }
    return returnSlide;
  };

  componentDidMount = () => {
    // this.refs.car.goTo(options.startPosition);
  };

  componentDidUpdate = () => {
    switch (this.props.railType.toLowerCase()) {
      case "epg":
        this.refs.car.goTo(this.state.options.startPosition); // auto slide to live section for epg
        break;
      default:
        break;
    }
  };

  nextSlide = () => {
    this.refs.car.next();
  };

  render = () => {

    const events = {
      onDragged: function (event) { },
      onChanged: function (event) { },
      onTranslate: function (event) { }
    };
    return (
      <React.Fragment>
        {this.props.data.length > 0 && (
          <div className="epgRailMobile">
            <OwlCarousel ref="car" options={this.state.options} events={events}>
              {this.crouselSlides(this.props.data)}
            </OwlCarousel>
          </div>
        )}
      </React.Fragment>
    );
  };
}

const mapStateToProps = state => {
  return {
    currentLanguage: state.language.currentLanguage
  };
};


const mapDispatchToProps = dispatch => {
  return {
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Carousel));


// export default Carousel;
